// DOM
import OcmMessenger from "ocm_mercurius_messenger";
import { messengerPublicationTypes } from "@ocm/services/services.constants.js";

let $secondaryNav;
let $secondaryNavLinks;

function init() {
	$secondaryNavLinks = $(".js-secondary-nav a");
	$secondaryNav = $(".js-secondary-nav");
	setActiveNavbarItem();

	// React to Route Changes
	OcmMessenger.subscribe(messengerPublicationTypes.ROUTE_CHANGE, () => {
		removeActiveClass();
		closeFlyout();
	});

	// eslint-disable-next-line prefer-arrow-callback
	$secondaryNavLinks.on("click", function () {
		$(this).closest(".js-secondary-nav__item").addClass("is-active");
	});
}

function setActiveNavbarItem() {
	let navItem;
	const breadcrumb = document.querySelector(".js-breadcrumb-wrapper ul li:nth-child(2) a");
	const secondaryNav = [...document.querySelectorAll(`.js-secondary-nav__link[href]`)];

	if (breadcrumb) {
		navItem = secondaryNav?.filter((el) => el.pathname === breadcrumb.pathname)?.[0]?.parentElement;
	} else {
		navItem = secondaryNav?.filter((el) => el.pathname === window.location.pathname)?.[0]?.parentElement;
	}

	if (navItem === undefined) {
		const secondaryNavItems = [...document.querySelectorAll(".js-secondary-nav__item")];
		navItem = secondaryNavItems.find((item) => {
			const subLinks = [...item.querySelectorAll(".js-nav-link[href], .js-nav-link[data-goto]")];

			return subLinks.some((el) => el.pathname === window.location.pathname || checkGotoPath(el));
		});
	}
	navItem?.classList.add("is-active");
}

function checkGotoPath(el) {
	return (
		el.dataset.goto &&
		new URL(
			el.dataset.goto.startsWith("http") ? el.dataset.goto : `https://${window.location.hostname}${el.dataset.goto}`
		).pathname === window.location.pathname
	);
}

const removeActiveClass = () => {
	$secondaryNav.find(".is-active").removeClass("is-active");
};

const closeFlyout = () => {
	$(".js-secondary-nav__item").removeClass("is-open");
};

export { init };
